import VerifyOtpForm from "./form";
export default VerifyOtpForm;
